import { Component, OnInit, OnDestroy } from '@angular/core';
import { Location } from '@angular/common';
import { AuthService } from '../services/auth.service';
import * as $ from 'jquery';
import { Subscription } from 'rxjs';
import { ValidationResult } from 'angular-auth-oidc-client';

@Component({
  selector: 'app-unauthorized',
  templateUrl: 'unauthorized.component.pug',
  styleUrls: ['./unauthorized.component.sass']
})
export class UnauthorizedComponent implements OnInit, OnDestroy {

  private message = "Az oldal megtekintéséhez be kell jelentkezni";

  constructor(private authService: AuthService) {

  }

  ngOnInit() {
    switch (this.authService.authorizationValidationResult) {
      case ValidationResult.MaxOffsetExpired:
        this.message = "Az ön számítógépének órája pontatlan, ami miatt a bejelentkezés nem lehetséges. Kérjük járjon el a GyIK-ban található megoldási javaslat szerint.";
        break;
      default:
        this.message = `Az oldal megtekintéséhez be kell jelentkezni (${this.authService.authorizationValidationResult})`;
    }
  }

  ngOnDestroy(): void {

  }
}



// WEBPACK FOOTER //
// ./src/app/unauthorized/unauthorized.component.ts